#import "../fragments/stageset-basic.graphql"

mutation SetDefaultStageset($stageset: SetDefaultStagesetInputFieldInput!) {
    setDefaultStageset(input: {stageset: $stageset}) {
        stagesets {
            ...StagesetBasic
        }
    }
}
